module.exports = __webpack_public_path__ + "img/b10.a341c854.jpg";